import { useQuery } from "@apollo/client";
import { CATEGORY_COMPANY_COUNT_QUERY } from "./queries/categoryCompanyCountQuery";
import { useProductCatalogContext } from "../ProductCatalogContext";
import { NumberCard } from "../components/NumberCard";
import { COMPANY_SEARCH_CLIENT } from "../../../utils/consts";

export const CompanyCountCard = (props: { leafCategoryIds: string[] }) => {
  const { entityTypeFilterValue, localizeInstalls } =
    useProductCatalogContext();
  const { data, loading } = useQuery(CATEGORY_COMPANY_COUNT_QUERY, {
    variables: {
      categoryIds: props.leafCategoryIds,
      localizeInstalls,
      ...entityTypeFilterValue,
    },
    skip: props.leafCategoryIds.length === 0,
    context: { clientName: COMPANY_SEARCH_CLIENT },
  });

  return (
    <NumberCard
      id="company-count"
      isLoading={loading}
      count={data?.opportunityGeneratorSearch.count || 0}
      title="Number of Companies"
    />
  );
};
